// extracted by mini-css-extract-plugin
export var content = "gamification-businnes-partners-zone-module--content--57ed6";
export var dropdown = "gamification-businnes-partners-zone-module--dropdown--67081";
export var linksWrapper = "gamification-businnes-partners-zone-module--links-wrapper--bfe0d";